import script from "./ModalMenuDownload.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalMenuDownload.vue?vue&type=script&setup=true&lang=js"

import "./ModalMenuDownload.vue?vue&type=style&index=0&id=74369ed0&lang=scss&scoped=true"

import exportComponent from "/Users/matteo.direnzo/Documents/TVA/eni-digit_eni-storia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74369ed0"]])

export default __exports__